"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _Tooltip = _interopRequireDefault(require("@cimpress/react-components/lib/Tooltip"));

var _react = _interopRequireDefault(require("react"));

var _ShortNumber = _interopRequireDefault(require("../ShortNumber"));

function PrimaryLink(props) {
  return _react.default.createElement("button", Object.assign({
    className: "btn btn-primary"
  }, props));
}

function SecondaryLink(props) {
  return _react.default.createElement("button", Object.assign({
    className: "btn btn-link"
  }, props));
}

var ActionButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ActionButton, _React$Component);

  function ActionButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ActionButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ActionButton).call(this, props));
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.onOpen = _this.onOpen.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      showTooltip: false
    };
    return _this;
  }

  (0, _createClass2.default)(ActionButton, [{
    key: "onClose",
    value: function onClose() {
      this.setState({
        showTooltip: false
      });
    }
  }, {
    key: "onOpen",
    value: function onOpen() {
      this.setState({
        showTooltip: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          count = _this$props.count,
          disabled = _this$props.disabled,
          label = _this$props.label,
          primary = _this$props.primary,
          secondary = _this$props.secondary,
          title = _this$props.title,
          tooltip = _this$props.tooltip;
      var showTooltip = this.state.showTooltip;
      var hasLabel = label !== null && label !== undefined;
      var cardLabel = label ? _react.default.createElement("div", {
        className: "card-label-container"
      }, _react.default.createElement("div", {
        className: "card-label"
      }, _react.default.createElement("h6", null, label))) : null;
      var hasCount = count !== null && count !== undefined;

      var cardCount = _react.default.createElement("div", {
        className: "action-button__count"
      }, _react.default.createElement(_ShortNumber.default, {
        numberClassName: "action-button__count__number",
        suffixClassName: "action-button__count__suffix",
        value: count
      }));

      var PrimaryComponent = this.props.primaryRenderer;
      var hasPrimary = primary !== null && primary !== undefined;
      var primaryButton = hasPrimary ? _react.default.createElement(PrimaryComponent, {
        disabled: disabled
      }, primary) : null;
      var SecondaryComponent = this.props.secondaryRenderer;
      var hasSecondary = secondary !== null && secondary !== undefined;
      var secondaryButton = hasSecondary ? _react.default.createElement(SecondaryComponent, {
        disabled: disabled
      }, secondary) : null;
      var hasButtons = primary || secondary;
      var cardButtons = hasButtons ? _react.default.createElement("div", {
        className: "action-button__buttons"
      }, primaryButton, secondaryButton) : null;
      var hasTooltip = !!tooltip;
      var cardTootltip = hasTooltip ? _react.default.createElement(_Tooltip.default, {
        containerClassName: "action-button__tooltip",
        contents: tooltip,
        customShow: showTooltip,
        direction: "bottom"
      }, '') : null;

      var card = _react.default.createElement("div", {
        className: disabled ? 'card disabled' : 'card',
        onBlur: this.onClose,
        onFocus: this.onOpen,
        onMouseOver: this.onOpen,
        onMouseOut: this.onClose
      }, cardLabel, _react.default.createElement("div", {
        className: "action-button card-block"
      }, _react.default.createElement("div", null, hasCount || hasLabel ? cardCount : null, _react.default.createElement("div", {
        className: "action-button__title"
      }, title), _react.default.createElement("div", {
        className: "action-button__body"
      }, children)), _react.default.createElement("div", {
        className: "action-button__spacer"
      }), cardButtons, cardTootltip));

      return card;
    }
  }]);
  return ActionButton;
}(_react.default.Component);

ActionButton.defaultProps = {
  primaryRenderer: PrimaryLink,
  secondaryRenderer: SecondaryLink
};
var _default = ActionButton;
exports.default = _default;